export enum PdfAspectRatioType {
  KEEP_CURRENT_SIZE = 'KEEP_CURRENT_SIZE',
  FIT_TO_PAGE = 'FIT_TO_PAGE',
}
